import { apiCall, ApiConfig } from '../../../config/api'
import { Filter } from '../../../components/_WMS/FilterComponent/types'//'../../../../../components/_WMS/FilterComponent/types'
import { TypePosition } from '../../../components/TypePosition/types/TypePosition'

export const getTypePositions = (
  filters: Filter[],
  page: number,
  pageSize: number
) => {
  const queryParams = new URLSearchParams()
  queryParams.append('pageIndex', page.toString())
  queryParams.append('pageSize', pageSize.toString())

  filters.forEach((filter) => {
    if (filter.value !== undefined && filter.value !== '') {
      queryParams.append(filter.key, filter.value.toString())
    }
  })

  const url = `${ApiConfig.TypepositionApi}?${queryParams.toString()}`
  return apiCall('GET', url)
}

export const getTypePositionById = (typePositionId: number) => {
  return apiCall('GET', `${ApiConfig.TypepositionApi}/${typePositionId}`)
}

export const updateTypePosition = (typePositionId: number, data: TypePosition) => {
  return apiCall(
    'PUT',
    `${ApiConfig.TypepositionApi}?typePositionId=${typePositionId}`,
    data
  )
}
